import { takeLeading } from 'redux-saga/effects';
import { get, isNull } from 'lodash';
import { callApi } from 'helpers/saga-helpers';
import userToken from 'containers/services/security/access-token-storage';
import { REQUEST_PREOPEN_MANAGER_PENDING_CLAIMS } from 'containers/PreOpenManagerPendingClaims/constants';
import { setPendingClaims } from 'containers/PreOpenManagerPendingClaims/actions';
import currentUserStorage from 'containers/services/security/current-user-storage';

export function* requestPendingClaims(action: {
  status: string;
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { status, page, pageSize } = action;
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const path = `/corporeal/common/claims?status=${status}&page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      name: get(currentUserStorage.get(), 'username'),
    },
  };
  yield callApi(path, {}, options, [], setPendingClaims);
}

export function* requestPendingClaimsSaga() {
  yield takeLeading(
    REQUEST_PREOPEN_MANAGER_PENDING_CLAIMS,
    requestPendingClaims,
  );
}

export default [requestPendingClaimsSaga];
